import { render, staticRenderFns } from "./ModalDetailPendalamanRegister.vue?vue&type=template&id=f638a92a&"
import script from "./ModalDetailPendalamanRegister.vue?vue&type=script&lang=js&"
export * from "./ModalDetailPendalamanRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports